/** Chiavi localStorage del flag «Ricordami» in pagina di login. */
export const REMEMBERED_EMAIL_KEY = "rememberedEmail";
export const REMEMBERED_PASSWORD_KEY = "rememberedPassword";

/**
 * Credenziali da riproporre nel form di login, o null se manca email o password.
 */
export function loadRememberedCredentials() {
  const email = localStorage.getItem(REMEMBERED_EMAIL_KEY);
  const password = localStorage.getItem(REMEMBERED_PASSWORD_KEY);
  if (!email || !password) {
    return null;
  }
  return { email, password };
}

export function persistRememberedCredentials(email, password) {
  localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  localStorage.setItem(REMEMBERED_PASSWORD_KEY, password);
}

/**
 * Solo un nuovo accesso con «Ricordami» spento deve cancellarle.
 * Il logout di sessione non deve chiamare questa funzione.
 */
export function forgetRememberedCredentials() {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
  localStorage.removeItem(REMEMBERED_PASSWORD_KEY);
}

/**
 * Esegue una mutazione sullo storage (es. clear) senza toccare «Ricordami».
 */
export function withRememberedCredentialsPreserved(mutateStorage) {
  const email = localStorage.getItem(REMEMBERED_EMAIL_KEY);
  const password = localStorage.getItem(REMEMBERED_PASSWORD_KEY);
  mutateStorage();
  if (email != null) {
    localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  }
  if (password != null) {
    localStorage.setItem(REMEMBERED_PASSWORD_KEY, password);
  }
}
